import { setConfigErrors } from "../../store/slices/errors";
import apiClient from "../../utils/api.client";
import { getOrganizationId } from "../../utils/session.utils";

let api_conf_url = process.env.REACT_APP_API_CONF_URL;

export async function getAllConfigurations(
  organizationId = getOrganizationId(),
) {
  try {
    const path = `/api-configuration/settings/config?organizationId=${organizationId}&integrations=GAMMA`;
    const response = await apiClient.get(path);
    return response.data;
  } catch (error) {
    console.error("Error at getAllConfigurations EP: ", error);
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(`Error at getAllConfigurations EP: ${error}`);
    }
  }
}

export async function createConfigItem(payload) {
  try {
    // El backend exige la organizacion (organization_id NOT NULL); la resolvemos por
    // gammaId a partir de la organizacion activa, igual que el resto de los endpoints.
    const body = { ...payload, organizationDTO: getOrganizationId() };
    const response = await fetch(`${api_conf_url}/settings/config/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    return response;
  } catch (e) {
    console.log(e);
  }
}

export function searchConfigItem(configKey) {
  return fetch(`${api_conf_url}/settings/config/predicted/${configKey}`)
    .then((res) => res.json())
    .then((json) => {
      return json;
    })
    .catch((err) => console.log(err));
}

export async function updateConfigItem(payload, dispatch) {
  try {
    const response = await fetch(`${api_conf_url}/settings/config/edit`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return response;
  } catch (e) {
    console.log(e);
    dispatch(setConfigErrors({ error: true, code: e.status || e.message }));
  }
}

export async function deleteConfigItem(configItemId) {
  try {
    const response = await fetch(
      `${api_conf_url}/settings/config/${configItemId}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      },
    );
    console.log("delete config response", response);
    return response;
  } catch (e) {
    console.log(e);
  }
}
